import React from "react"
import Resume from "../lib/resume"
import { GlobalWrapper } from "../lib/common"

export default function () {
  return (
    <GlobalWrapper>
      <Resume />
    </GlobalWrapper>
  )
}
